// Full-document render of the tempurpedic FlagshipAll page: PageSkeleton (the
// React document shell) wrapping two body sections in order (normal site
// chrome):
//
// 1. `.quicksearch` -- the raw title bar + headline around the shared
//    LocatorQuickSearchSSR component, fed by the page's two visibility
//    flags. The two headings arrive server-gettext-resolved (fr_CA); the
//    retailer heading's msgid embeds a literal `&reg;` entity, injected raw
//    so it keeps rendering as the (R) character.
// 2. `.locations` -- the shared FlagshipNearestStoresSSR component, rendered
//    with `max_tiles=99 include_location_info=False`.
import React from "react";

import { templates } from "@reactivated";

import { FlagshipNearestStoresSSR } from "../apps/retail-locator/FlagshipNearestStoresSSR";
import { LocatorQuickSearchSSR } from "../apps/retail-locator/LocatorQuickSearchSSR";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
type IProps = templates.FlagshipAllTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="quicksearch">
                <div className="quicksearch__title-bar">
                    <h1
                        className="quicksearch__title"
                        dangerouslySetInnerHTML={{
                            __html: props.find_retailer_heading,
                        }}
                    />
                </div>
                <h2 className="quicksearch__headline">
                    {props.quick_search_heading}
                </h2>
                <section className="l-capped-width">
                    <LocatorQuickSearchSSR
                        selected_item="flagship"
                        hide_elite={props.page.hide_elite}
                        hide_tp_stores={props.page.hide_tp_stores}
                    />
                </section>
            </div>
            <div className="locations">
                <div className="locations__container">
                    <FlagshipNearestStoresSSR
                        max_tiles={99}
                        include_location_info={false}
                    />
                </div>
            </div>
        </PageSkeleton>
    );
};
